import { useMutation, useQueryClient } from '@tanstack/react-query';

import { APP_EXCLUSIVE_BRAND, APP_EXCLUSIVE_SCHEDULE_TYPE } from '~/consts/appExclusive';

import OffersService from '~/services/OffersService';

import { appExclusiveScheduleQueryKeys } from './useGetAppExclusiveSchedules';
import { offerQueryKeys } from './useGetOffer';

export interface CreateAppExclusiveScheduleInput {
  offerId: string;
  region: string;
  /** Slot start and end as returned by the eligible lookup (6:00am Sydney, running 24 or 48 hours). */
  start: string;
  end: string;
}

export function useCreateAppExclusiveSchedule() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ offerId, region, start, end }: CreateAppExclusiveScheduleInput) =>
      OffersService.createSchedule(
        { type: APP_EXCLUSIVE_SCHEDULE_TYPE, brand: APP_EXCLUSIVE_BRAND, region, start, end },
        offerId,
      ),
    onSuccess: (_data, { offerId }) => {
      // Covers both the calendar lists and the eligible lookup, which nest under the same root key.
      queryClient.invalidateQueries({ queryKey: appExclusiveScheduleQueryKeys.all });
      queryClient.invalidateQueries({ queryKey: offerQueryKeys.detail(offerId) });
    },
  });
}
